export class CRMHierarquiaUsuario {
  idFuncion: number;
  nome: string;
  superior?: number;
  funilPadrao?: number;
  filhos?: CRMHierarquiaUsuario[];
  esconderFilhos?: boolean = false;
  checado?: boolean = false;
  recuo?: number;
  verMesmoNivelFunil?: boolean;
  nomeTimeFunil?: string;
  limDesc?: number;
  nomeTimeCrm?: string;
  crmPadrao?: any;
  verSomenteHierarquia?: boolean;
}
